import { makeStyles } from '@mui/styles'

const useLandingStyles = makeStyles((theme) => ({
  root: {},
}))

export default useLandingStyles
